import { Link as RouterLink, useParams } from "react-router-dom";
import { Box, Link } from "@chakra-ui/react";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import PlacementWorkspace from "./components/placing/PlacementWorkspace";

/** One placement in the placing portal. */
const PlacingPlacementPage = () => {
  const { placementId } = useParams();
  return (
    <Box position="relative" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />
      <Box p={6} maxW="1400px" mx="auto">
        <Link as={RouterLink} to="/placing" color="blue.600" fontSize="sm" mb={3} display="inline-block">
          ← All placements
        </Link>
        <PlacementWorkspace placementId={placementId} />
      </Box>
    </Box>
  );
};

export default PlacingPlacementPage;
